import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Banner = () => {
  const { t } = useTranslation();

    return (
      <div className='tw-w-full tw-max-w-[1440px] tw-mx-auto tw-px-4 lg:tw-px-16 tw-mt-10 tw-mb-10'>
        <div className='tw-bg-[#280D41] tw-border tw-border-white/10 tw-rounded-2xl tw-flex tw-flex-col sm:tw-flex-row tw-items-center tw-justify-center tw-gap-4 sm:tw-gap-8 tw-w-full tw-p-6 sm:tw-p-8'>
          <p className='tw-text-center tw-font-bold tw-text-white tw-m-0'>
            {t('Present your film like a PRO, for FREE with KinoKlik EPK!')}
          </p>
          <Link to="/dashboard/epks">
            <button className='tw-bg-[#FF43A7] hover:tw-bg-[#ff5cac] tw-text-white tw-uppercase tw-font-bold tw-py-3 tw-px-8 tw-rounded-full tw-border-none tw-shadow-[0_10px_25px_rgba(255,67,167,0.35)] tw-transition-colors tw-cursor-pointer tw-whitespace-nowrap'>
              {t('CREATE EPK')}
            </button>
          </Link>
        </div>
      </div>
    );
  };

  export default Banner;

  